var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.71,
    height: 65.15,
    viewBox: "0 0 64.71 65.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "parking"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 43.74,
    y1: 59.1,
    x2: 21.86,
    y2: 59.1,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.76,58.67l-2.56-1.22c-.08-.04-.16-.08-.24-.13l-3.01-1.8c-.84-.5-1.35-1.41-1.35-2.39v-8.21c0-.78.32-1.52.89-2.04l1.37-1.27c.8-.74,1.09-1.89.75-2.92l-1.9-2.11c-.11-.32.13-.65.47-.65l6.67-.89.44-.04c10.42-1.69,20.07-2.4,26.61.85.32.06,11.81,7.36,11.81,7.36.78.5,1.69.78,2.62.81l5.6.14c2.09.05,4.14.74,5.72,2.1.7.61,1.31,1.31,1.75,2.07.5.85.7,1.84.7,2.83,0,1.21,0,3.39,0,5.16,0,1.54-1.25,2.78-2.78,2.78h-3.48",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.91,
    cy: 57.4,
    r: 7.16,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.69,
    cy: 57.4,
    r: 7.16,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "49.8 43.97 14.13 43.97 10.44 39.51",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.31,
    y1: 43.97,
    x2: 23.17,
    y2: 33.58,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.11,
    cy: 16.25,
    r: 10.73,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(42.92 22.07)",
    style: {
      fill: "#4d4d4d",
      fontFamily: "Calibri-Light, Calibri",
      fontSize: "18.14px",
      fontWeight: 300,
      stroke: "#4d4d4d",
      strokeMiterlimit: 10
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("path", {
    d: "m38.17,34.14l-5.86-12.41c-2.2-6.02-.53-12.77,4.22-17.07h0c6.15-5.56,15.56-5.4,21.51.37l.39.38c4.87,4.73,6.17,12.04,3.21,18.15l-10.04,17.73",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.fa5c77833d508530b7133ba029d8c9ee.svg";
export { ForwardRef as ReactComponent };